import { PROJECTNAME } from "../utils/constants";

export const engagingMessages: string[] = [
    `Unlock Your Tech Superpowers with ${PROJECTNAME} — Magic Happens Here!`,
    `Upskill with ${PROJECTNAME} — Where Future Tech Wizards Are Made!`,
    `Transform into a Tech Genius with ${PROJECTNAME} — No Potions, Just Knowledge!`,
    `Become a Tech Sorcerer with ${PROJECTNAME} — Your Spellbook for Success!`,
    `Up Your Game with ${PROJECTNAME} — No Fairy Dust, Just Real Skills!`,
    `Level Up Your Tech Skills with ${PROJECTNAME} — We Make You the Wizard of Code!`,
    `Master Tech with ${PROJECTNAME} — No Wand, Just Hard Work and Magic!`,
    `Transform into a Tech Master with ${PROJECTNAME} — Your Wizardry Starts Here!`,
    `${PROJECTNAME} — Where Ordinary People Become Extraordinary Tech Wizards!`,
    `Magically Upgrade Your Skills with ${PROJECTNAME} — No Spellcasting Necessary!`,
    `Unleash Your Inner Tech Wizard with ${PROJECTNAME} — The Power of Knowledge Awaits!`,
    `Master the Tech Universe with ${PROJECTNAME} — A Wand Won't Help, But We Will!`,
    `${PROJECTNAME}: Your Tech Journey Starts Here — Unlock Your Wizard Potential!`,
    `Step into the World of Tech Wizards with ${PROJECTNAME} — No Wand Needed!`,
    `${PROJECTNAME} — Learn, Grow, and Become a Tech Wizard Without the Need for Spells!`,
    `Up Your Tech Game with ${PROJECTNAME} — Create, Innovate, Dominate!`,
    `${PROJECTNAME} — Learn the Magic Behind the Code and Become the Ultimate Tech Wizard!`,
    `No Wand, No Potion — Just Pure Tech Mastery with ${PROJECTNAME}!`,
    `Elevate Your Skills with ${PROJECTNAME} — Where Wizards Are Made, Not Born!`,
    `Tech Wizards Wanted: Upskill with ${PROJECTNAME} Now!`,
    `${PROJECTNAME} — A Shortcut to Mastering Tech Magic!`,
    `Become a Code Wizard with ${PROJECTNAME} — Unlock Your Power with Every Line of Code!`,
    `${PROJECTNAME} — Where Ordinary Learners Become Extraordinary Wizards of Technology!`,
    `Tech Mastery Awaits You — Join ${PROJECTNAME} and Cast Your First Code Spell!`,
    `Rise Above the Rest with ${PROJECTNAME} — Your Magic Portal to Tech Mastery!`,
    `Turn Your Tech Dreams into Reality with ${PROJECTNAME} — No Magic Needed!`,
    `Up Your Tech Skills with ${PROJECTNAME} — Learn, Grow, and Conquer the Digital Realm!`,
    `${PROJECTNAME} — Your Ultimate Guide to Becoming a Tech Wizard (No Potions Required!)`,
    `Join ${PROJECTNAME} Today — Discover the Magic of Tech Skills and Knowledge!`,
    `Unlock the Secrets of Tech Wizardry with ${PROJECTNAME} — Become a Master of the Digital World!`,
    `${PROJECTNAME} — Tech Mastery at Your Fingertips, No Wand Required!`,
    `Your Journey to Tech Wizardry Starts with ${PROJECTNAME} — Unlock Your Inner Genius!`,
    `${PROJECTNAME} — The Gateway to a World of Tech Magic and Infinite Possibilities!`,
    `Upskill with ${PROJECTNAME} — Your Magic Key to Unlocking the Secrets of Technology!`,
    `Turn the Impossible into Possible with ${PROJECTNAME} — No Spells, Just Skills!`,
    `Tech Wizardry Awaits — Take Your Skills to the Next Level with ${PROJECTNAME}!`,
    `${PROJECTNAME} — Master Tech with Ease and Become the Wizard of Your Future!`,
    `Becoming a Tech Wizard Has Never Been Easier — Join ${PROJECTNAME} Now!`,
    `${PROJECTNAME} — From Beginner to Tech Wizard in No Time!`,
    `Empower Yourself with ${PROJECTNAME} — The Ultimate Tech Wizard Academy!`,
    `${PROJECTNAME} — Unlock Your Full Tech Potential and Become the Wizard You Were Meant to Be!`,
    `Tech Mastery is a Spell Away — Learn It with ${PROJECTNAME}!`,
    `${PROJECTNAME} — Turn Your Passion into Tech Mastery and Wizardry!`,
    `Becoming a Tech Wizard Starts with the Right Course — ${PROJECTNAME} is Here for You!`,
    `${PROJECTNAME} — Your Tech Adventure Starts Here, No Wand Needed!`,
    `Join the Tech Revolution with ${PROJECTNAME} — A Tech Wizard in the Making!`,
    `${PROJECTNAME} — The Path to Tech Wizardry is Just One Click Away!`,
    `Ready to Become a Tech Wizard? Upskill with ${PROJECTNAME} Today!`,
    `Master the Art of Technology with ${PROJECTNAME} — No Magic, Just Mastery!`,
    `Tech Wizardry Starts Here — Take the First Step with ${PROJECTNAME}!`,
    `${PROJECTNAME} — Your Shortcut to Unlocking the Secrets of Tech Wizardry!`,
    `From Learner to Wizard — ${PROJECTNAME} Will Guide You Every Step of the Way!`,
    `${PROJECTNAME} — The Future of Tech Wizards Starts with Us!`,
    `Upskill with ${PROJECTNAME} — Your Magic Carpet Ride to the World of Tech Mastery!`,
    `Tech Wizardry is Just a Course Away — Join ${PROJECTNAME} and Unlock Your Power!`,
    `${PROJECTNAME} — The Place Where Tech Wizards Are Born!`,
    `Learn to Code, Create Magic — Upskill with ${PROJECTNAME}!`,
    `${PROJECTNAME} — Unlock the Power of Tech and Become the Wizard You’ve Always Wanted to Be!`,
    `Step into the World of Technology Wizardry with ${PROJECTNAME} — No Wand, Just Knowledge!`,
    `${PROJECTNAME} — The Ultimate Platform for Aspiring Tech Wizards!`,
    `Upskill Now with ${PROJECTNAME} — The Fast-Track to Becoming a Tech Wizard!`,
    `Your Future as a Tech Wizard Begins with ${PROJECTNAME}!`,
    `${PROJECTNAME} — Transform Your Career, Become a Tech Wizard Today!`,
    `Master the Art of Coding with ${PROJECTNAME} — Your Tech Wizard Journey Starts Now!`,
    `${PROJECTNAME} — The Magic Behind Tech Mastery Awaits You!`,
    `Learn, Create, Innovate — Become a Tech Wizard with ${PROJECTNAME}!`,
    `${PROJECTNAME} — The Key to Unlocking Your Full Tech Potential!`,
    `Level Up Your Tech Skills with ${PROJECTNAME} — The Fast Track to Becoming a Tech Wizard!`,
    `${PROJECTNAME} — The Academy for Aspiring Tech Wizards Everywhere!`,
    `Become a Code Wizard with ${PROJECTNAME} — Unlock Your Power and Skills Today!`,
    `${PROJECTNAME} — Unleash Your Inner Tech Wizard with Every Click!`,
    `No Wand, Just Skills — Upskill with ${PROJECTNAME} Now!`,
    `${PROJECTNAME} — Your Tech Wizard Journey Begins Here!`,
    `Up Your Tech Game with ${PROJECTNAME} — The Wizardry Starts Here!`,
    `${PROJECTNAME} — Unlock Your Potential and Master the Digital World!`,
    `Become the Tech Wizard You’ve Always Dreamed of with ${PROJECTNAME}!`,
    `${PROJECTNAME} — Where Future Tech Wizards Find Their Magic!`,
    `Unlock the Power of Tech Wizardry with ${PROJECTNAME}!`,
    `${PROJECTNAME} — Your Path to Tech Mastery Starts Right Here, Right Now!`,
    `Tech Wizardry in Action — Join ${PROJECTNAME} and Learn the Craft!`,
    `${PROJECTNAME} — Your Future as a Tech Wizard is Waiting for You!`,
    `Level Up Your Tech Skills — The Tech Wizard Journey Starts with ${PROJECTNAME}!`,
    `${PROJECTNAME} — Your Ticket to Unlocking the Magic of Technology!`,
    `Ready to Learn the Magic of Tech? ${PROJECTNAME} is Your Guide!`,
    `${PROJECTNAME} — Take the Leap and Become a Tech Wizard Today!`,
    `Tech Wizardry is Just a Click Away with ${PROJECTNAME}!`,
    `${PROJECTNAME} — A New Era of Tech Wizards Starts Here!`,
    `Upskill Now, Become a Tech Wizard Later — Join ${PROJECTNAME}!`,
    `${PROJECTNAME} — The Only Course You Need to Unlock Your Tech Wizardry Potential!`,
    `Embrace the Magic of Tech with ${PROJECTNAME} — Become a Wizard in Your Field!`,
    `${PROJECTNAME} — Where Learning Meets Magic and Tech Meets Wizardry!`,
    `Upskill with ${PROJECTNAME} — Your Secret Weapon to Becoming a Tech Wizard!`,
    `Get guided learning paths, expert mentorship, and curated courses—all in one place.`
  ];

 export const assistanceMessages: string[] = [
    "Need Help?",
    "Need Support?",
    "We're Here!",
    "Help Me!",
    "Need Assistance?",
    "Stuck Somewhere?",
    "Help Needed?",
    "Need Guidance?",
    "Got a Problem?",
    "Questions? Ask!",
    "Chahiye Help?",
    "Aapko Madad?",
    "Bhi Koi Query?",
    "Need a Hand?",
    "Support Required?",
    "Assistance Please!",
    "Help? Here!",
    "We Got You!",
    "Doubt Hai?",
    "Help Available!",
    "Kuch Samajh Nahi?",
    "Just Ask Us!",
    "Need Solution?",
    "We're Ready!",
    "Ask Away!",
    "Madad Chahiye?",
    "Solution Here!",
    "Need Fix?",
    "We Help!",
    "Koi Problem?",
    "Tension Mat Lo!",
    "Got Questions?",
    "Ready to Help!",
    "Need Tips?",
    "Quick Help?",
    "Chahiye Solution?",
    "Help at Hand!",
    "Doubt Khatam!",
    "Support Me!",
    "Query? Solve It!",
    "Problem Solved!",
    "Let's Fix It!",
    "Kuch Poochna Hai?",
    "Any Issues?",
    "Chalo Help Karte Hai!",
    "Stuck? Ask!",
    "In Trouble?",
    "Humein Bataye!",
    "Need a Fix?",
    "Aapko Guide Karein?",
    "We're Available!",
    "Aapka Solution!",
    "Don't Worry!",
    "Fixing It Now!",
    "Difficulties? Help Us!",
    "Problem? We're Here!",
    "Koi Rukawat?",
    "Need Help? Here!",
    "We Solve It!",
    "Madad Chahiye?",
    "Help on Way!",
    "Got Issues?",
    "Quick Help Here!",
    "Assistance Coming!",
    "Chalo Solve Karein!",
    "Help Coming Soon!",
    "Questions Solved!",
    "Doubt Clear!",
    "Need Aid?",
    "Need Help Now?",
    "Problem? Let's Solve!",
    "We’re Here for You!",
    "Kuch Samajh Nahi Aaya?",
    "Let’s Do It!",
    "Solutions Ready!",
    "We Got Your Back!",
    "Aapka Sawal?",
    "Fix It Fast!",
    "Kuch Problem Hai?",
    "Let’s Resolve It!",
    "Solution Hai!",
    "Aapka Help?",
    "Let’s Fix Now!",
    "Need Support Now?",
    "Sawaal Karo!",
    "Let Us Help!",
    "Solution Coming!",
    "Madad Mil Rahi Hai!",
    "Tension Free!",
    "Let’s Work Together!",
    "We Solve Problems!",
    "Aapko Help Chahiye?",
    "Need Quick Help?",
    "No Worries Here!",
    "We’ll Fix That!",
    "Kya Hai Problem?",
    "We’re On It!",
    "Just Ask Us!",
    "Need Help Fast?",
    "Tension Nahi!",
    "Aapka Solution!",
    "We’ll Handle It!",
    "Fixing Problems!",
    "Need a Boost?",
    "Ask for Help!",
    "Help? We’re Here!",
    "Let’s Help You!",
    "Got a Query?",
    "Need Assistance Now?",
    "Aapki Madad!",
    "Just Ask Us!",
    "Assistance On Way!",
    "Support Here!",
    "Problem Solved Soon!",
    "Fixing It Now!"
  ];

  export const searchMessages: string[] = ["Search for courses","Search for tutorials","Search for interviews","Search for mentor","Search for campus counselor"]
  
  